import React from "react";
import { Image, Text, View } from "react-native";
import swiperHelperStyle from "./swiperHelper.style";
import MediaQuery from "react-native-web-responsive";

function Slice1(props) {
  return (
    <View style={swiperHelperStyle.slide1}>
      <View
        style={{
          flex: 1,
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "flex-end",
          marginBottom: "50px",
        }}
      >
        <Image
          style={{ height: 150, width: 150, marginVertical: 20 }}
          source={require("../../../assets/slider1.png")}
        />
        <Text
          style={{
            color: "#383638",
            fontSize: 18,
            fontFamily: "Ubuntu-Bold",
            marginBottom: "4%",
            textAlign: "center",
          }}
        >
          Selecciona la sucursal que más te acomode
        </Text>

        <Text
          style={{
            textAlign: "center",
            color: "#383638",
            fontSize: 14,
            fontFamily: "Ubuntu-Regular",
            lineHeight: 20,
          }}
        >
          Podrás elegir a tu conveniencia, desde un mapa o desde una lista, las 
          sucursales más cercanas a tí. En listado podrás visualizar si la sucursal 
          se encuentra "Abierta" o "Cerrada".
        </Text>
        <MediaQuery minWidth={1224}>
          <View
            style={{
              marginTop: "60px",
              height: 1,
              width: "100%",
              backgroundColor: "#e1e8ee",
            }}
          />
        </MediaQuery>
        <MediaQuery maxWidth={1223}>
          <View
            style={{
              marginTop: "10px",
              height: 1,
              width: "100%",
              backgroundColor: "#e1e8ee",
            }}
          />
        </MediaQuery>
      </View>
    </View>
  );
}

export default Slice1;
